import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, switchMap, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RmaPreloadingStrategy implements PreloadingStrategy {
  //We can use route data to prioritise routes if we want
  preload(_route: Route, load: () => Observable<unknown>): Observable<unknown> {
    //This is for testing
    const duration = 3000;
    const loadRoute = (delay?: boolean) => (delay ? timer(duration).pipe(switchMap((_) => load())) : load());
    return loadRoute(true);
  }
}
